(function () {
  var DEFAULT_INTERVAL = 3000;
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initBadgeRotate(scope) {
    if (prefersReducedMotion) return;

    var root = scope || document;
    var containers = root.querySelectorAll
      ? root.querySelectorAll('.halo-productBadges--rotate:not([data-badge-rotate-ready])')
      : [];

    if (!containers.length && root.classList && root.classList.contains('halo-productBadges--rotate') && !root.hasAttribute('data-badge-rotate-ready')) {
      containers = [root];
    }

    containers.forEach(function (container) {
      var badges = Array.prototype.slice.call(container.querySelectorAll('.badge'));

      if (badges.length <= 1) {
        if (badges[0]) badges[0].classList.add('is-active');
        container.setAttribute('data-badge-rotate-ready', '');
        return;
      }

      var index = 0;
      var interval = parseInt(container.getAttribute('data-badge-rotate-interval'), 10) || DEFAULT_INTERVAL;

      badges.forEach(function (badge) {
        badge.classList.remove('is-active');
      });
      badges[0].classList.add('is-active');
      container.setAttribute('data-badge-rotate-ready', '');

      var timerId = window.setInterval(function () {
        if (!container.isConnected) {
          window.clearInterval(timerId);
          return;
        }

        badges[index].classList.remove('is-active');
        index = (index + 1) % badges.length;
        badges[index].classList.add('is-active');
      }, interval);

      container._badgeRotateTimer = timerId;
    });
  }

  function observeNewBadges() {
    if (!document.body || typeof MutationObserver === 'undefined') return;

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        initBadgeRotate(document);
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initBadgeRotate(document);
      observeNewBadges();
    });
  } else {
    initBadgeRotate(document);
    observeNewBadges();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initBadgeRotate(event.target || document);
  });
})();
